export const SUPER_PRODUCT_COLUMNS = ['no', 'name'];

export const LINKED_PRODUCT_COLUMNS = ['name', 'short', 'actions'];

export const SUPER_PRODUCT_MESSAGES = {
	EMPTY_NAME: 'Name cannot be empty',
	COULD_NOT_SAVE: "Couldn't save",
	COULD_NOT_CREATE: "Couldn't create",
	SAVED: 'Saved',
	NO_PRODUCTS: 'There are no products',
	PRODUCTS: 'Products',
	CREATE: 'Create',
	SAVE: 'Save',
	CREATE_SUPER_PRODUCT: 'Create super product',
	EDIT_SUPER_PRODUCT: 'Edit super product',
	NAME: 'Name',
};
